import { EventEmitter, Injectable, Output } from '@angular/core';
import * as _ from 'lodash';
import { SocketService } from './socket.service';
import * as _s from 'underscore.string';
import { FilterStringService } from './filter-string.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogcatService {
  @Output() logdata: EventEmitter<any> = new EventEmitter();

  started: boolean = false;
  _serverFilters: any[] = [
    {
      tag: '',
      priority: 2
    }
  ];

  filters: any = {
    entries: [],
    levelNumbers: []
  };

  private _filters: any = {};

  deviceSerial = []

  deviceEntries = {}

  filterChar: String

  logLevels = [
    'UNKNOWN',
    'DEFAULT',
    'VERBOSE',
    'DEBUG',
    'INFO',
    'WARN',
    'ERROR',
    'FATAL',
    'SILENT'
  ]
  allowClean: boolean;

  constructor(
    private socketService: SocketService,
    private filterStringService: FilterStringService
  ) {
    this.defineFilterProperties([
      'levelNumber',
      'message',
      'pid',
      'tid',
      'dateLabel',
      'date',
      'tag',
      'priority'
    ]);


    // const logLevelsLowerCase = _.map(this.logLevels, level => level.toLowerCase());
    // const logLevelsCapitalized = _.map(logLevelsLowerCase, level => _s.capitalize(level));


    this.logLevels.forEach((level: string, index: number) => {
      if (index >= 1 && index < 8) {
        this.filters.levelNumbers.push({ number: index, name: _.capitalize(level) });
      }
    });

    this.socketService.socket.on('logcat.entry', (rawData: any) => {
      this.deviceSerialExist(rawData.serial);
      const tmpObject = this.enhanceEntry(rawData);
      if (this.filterChar == rawData.priorityLabel || this.filterChar == undefined) {
        this.logdata.emit(tmpObject)
      }



      if (!Object.keys(this.deviceEntries).includes(rawData.serial)) {
        this.deviceEntries[rawData.serial] = {
          logs: [],
          selectedLogLevel: 2,
          started: true
        };
      }

      this.deviceEntries[rawData.serial].logs.push(this.enhanceEntry(tmpObject));
      // if (typeof this.logcatTable.addEntryListener === 'function') {
      //   if (this.filterLine(rawData)) {
      //     rawData.logsSerial = this.deviceSerial;
      //     this.logcatTable.addEntryListener(rawData);
      //   }
      // }
    });
  }

  // Need to check <-----------------------------------
  // service.filters.filterLines = function() {
  //   let devSerial = (window.location.href).split('/').pop()

  //   if (Object.keys(service.deviceEntries).includes(devSerial)) {
  //     service.filters.entries = _.filter(service.deviceEntries[devSerial].logs.entries, filterLine)
  //   }

  //   if (typeof (service.addFilteredEntriesListener) === 'function') {
  //     service.addFilteredEntriesListener(service.filters.entries)
  //   }
  // }





  defineFilterProperties(properties: any[]) {
    properties.forEach(prop => {
      Object.defineProperty(this._filters, prop, {
        get: () => this._filters[prop],
        set: (value) => {
          this._filters[prop] = value || null;
          this._serverFilters[0][prop] = value || undefined;
          this.filterLines();
        }
      });
    });
  }
  filterLines() {
    let devSerial = (window.location.href).split('/').pop()

    if (Object.keys(this.deviceEntries).includes(devSerial)) {
      this.filters.entries = this.deviceEntries[devSerial].logs.entries.filter(this.filterLine);

      // this.filters.entries = _.filter(this.deviceEntries[devSerial].logs.entries, filterLine)
    }
    
    // if (typeof (this.addFilteredEntriesListener) === 'function') {
    //   service.addFilteredEntriesListener(service.filters.entries)
    // }
  }

  enhanceEntry(data: any) {
    const date = new Date(data.date * 1000);
    data.dateLabel =
      _s.pad(date.getHours(), 2, '0') + ':' +
      _s.pad(date.getMinutes(), 2, '0') + ':' +
      _s.pad(date.getSeconds(), 2, '0') + '.' +
      _s.pad(date.getMilliseconds(), 3, '0');

    data.deviceLabel = 'Android';
    data.priorityLabel = _.capitalize(this.logLevels[data.priority]);

    return data;
  }

  deviceSerialExist(serial: any) {
    if (!this.deviceSerial.includes(serial)) {
      this.deviceSerial.push(serial);
    }
  }

  initDeviceLogCollector(serial: any) {
    return this.deviceEntries[serial] = {
      logs: [],
      selectedLogLevel: 2,
      started: false,
      allowClean: false,
      filters: {
        levelNumber: this.filters.levelNumbers,
        message: '',
        pid: '',
        tid: '',
        dateLabel: '',
        date: '',
        tag: ''
      }
    };




  }

  clear() {
    const devSerial = window.location.href.split('/').pop();
    if (Object.keys(this.deviceEntries).includes(devSerial)) {
      this.deviceEntries[devSerial].logs = [];
    }
  }

  filterLine(line: any) {
    let matched = true;
    const devSerial = line.serial;
    const filters = this.deviceEntries[devSerial].filters;

    if (typeof filters !== 'undefined') {
      if (!_.isEmpty(filters.priority.toString())) {
        matched = line.priority >= filters.priority && matched;
      }
      if (!_.isEmpty(filters.date)) {
        matched = this.filterStringService.filterString(filters.date, line.dateLabel) && matched;
      }
      if (!_.isEmpty(filters.pid)) {
        matched = this.filterStringService.filterInteger(filters.pid, line.pid) && matched;
      }
      if (!_.isEmpty(filters.tid)) {
        matched = this.filterStringService.filterInteger(filters.tid, line.tid) && matched;
      }
      if (!_.isEmpty(filters.tag)) {
        matched = this.filterStringService.filterString(filters.tag, line.tag) && matched;
      }
      if (!_.isEmpty(filters.message)) {
        matched = this.filterStringService.filterString(filters.message, line.message) && matched;
      }
    }

    return matched;
  }

}
